import React from "react";
import { Typography, Grid, Box } from '@mui/material';
import { Link } from 'react-router-dom';

import "./TeamDraftYear.css"
import PlayerCard from "../PlayerCard/PlayerCard";

function TeamDraftYear({ draft_year, draft_grade }) {

    function pickAndRoundToOverall(pick, round, year) {
        var team_count = 30
        if (year >= 2021) {
            team_count = 32
        }
        else if (year >= 2017) {
            team_count = 31
        }
        return pick + (round - 1) * team_count
    }

    function getTopPicks(picks) {
        if (picks.length > 4) {
            return picks.slice(0, 5)
        }
        return picks
    }

    function getRemainingPicks(picks) {
        if (picks.length > 4) {
            return picks.slice(5, picks.length)
        }
        return []
    }


    const sortedPicks = draft_year?.picks
        ? [...draft_year.picks].sort((a, b) =>
            pickAndRoundToOverall(a.pick, a.round, draft_year.draft_year) -
            pickAndRoundToOverall(b.pick, b.round, draft_year.draft_year)
        )
        : [];

    return (
        <Grid item xs={12} sm={12} md={12}>
            <div className="container">
                <div className="draft-year-section-header">
                    <Typography variant="body1" className="draft_year">
                        {draft_year.draft_year} Draft Results
                    </Typography>
                    {draft_grade && <Typography variant="body1" className="draft_grade">
                        <span className="grade_text">Grade:</span> {draft_grade}
                    </Typography>}
                </div>

                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: 'repeat(2, minmax(0, 1fr))',
                            sm: 'repeat(3, minmax(0, 1fr))',
                            md: 'repeat(5, minmax(0, 1fr))',
                        },
                        gap: 2,
                        p: 1,
                    }}
                >
                    {getTopPicks(sortedPicks).map((draft_pick) => (
                        <Box key={draft_pick.player_id}>
                            {draft_pick && (
                                <PlayerCard
                                    playerData={draft_pick}
                                    ranking={pickAndRoundToOverall(
                                        draft_pick.pick,
                                        draft_pick.round,
                                        draft_pick.draft_year
                                    )}
                                />
                            )}
                        </Box>
                    ))}
                </Box>
                <Grid container spacing={0} padding={0}>
                    {getRemainingPicks(sortedPicks).map((draft_pick) => (
                        <Grid item xs={12} sm={12} md={12} key={draft_pick.player_id}>
                            {draft_pick &&
                                <Link  to={"../player/" + draft_pick.player_id}  className="lesser_pick">
                                        <Typography variant="body1">
                                            {pickAndRoundToOverall(draft_pick.pick, draft_pick.round, draft_pick.draft_year)}.
                                        </Typography>
                                        <Typography variant="body1" className="player-name">
                                            {draft_pick.first_name} {draft_pick.last_name}
                                        </Typography>
                                        <div className="sub-heading-divider"></div>
                                        <Typography variant="body1" className="sub-info">
                                            {draft_pick.country_name}
                                        </Typography>
                                        <div className="sub-heading-divider"></div>
                                        <Typography variant="body1" className="sub-info">
                                            {draft_pick.position}
                                        </Typography>
                                        <div className="sub-heading-divider"></div>
                                        <Typography variant="body1" className="sub-info">
                                            {draft_pick.weight && draft_pick.weight + " lbs"}
                                        </Typography>
                                        <div className="sub-heading-divider"></div>
                                        <Typography variant="body1" className="sub-info">
                                            {draft_pick.height && draft_pick.height}
                                        </Typography>
                                </Link>
                            }
                        </Grid>
                    ))}
                </Grid>
            </div>
        </Grid>
    )

}


export default TeamDraftYear;